import { ConfigProvider } from 'cn-next';
import { componentName } from 'src/const';
import ListFilter from 'src/view';
const Index = ConfigProvider.config(ListFilter, {
    componentName,
});
Index.displayName = componentName;
export default Index;
